<template>
  <section class="section7 text-center">
    <div class="container">
      <div class="row">
        <div class="col-12 pr-0">
          <div class="tableResult" :style="tableResultStyle">
            <ul>
              <li v-for="(level, index) in graphLevels" :key="index">
                <strong :style="strongStyle()">{{ level }}</strong>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 pl-0">
          <div>
            <p class="lightblueTxt mb-4">{{ $t('main.inhaler.heading') }}</p>
            <div class="lightblue_btn_gradient inspiratory-btn" style="background: url('images/blue-bg.png');">
              <a href="javascript:void(0)">
                <img src="images/inspiratory-img.png" alt="Table Result" class="d-block img-fluid"/>
                <div class="middleTxt">
                  <span>{{ maxFlowDampened }}</span>
                  <strong>L/min</strong>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button
            @click="viewResults"
            class="btn blueBtn2 mt-4"
            v-if="showButton"
          >View result</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AudioAnalyser from "~/js/AudioAnalyser.js"

export default {
  data () {
    return {
      analyser: null,
      resetTO: null,
      clearDelay: 5000,
      showButton: false,
      graphLevels: [310, 300, 270, 240, 210, 180, 150, 120, 90, 60, 30]
    }
  },

  computed: {
    ...mapGetters({
      stream: 'inhaler/stream',
      selectedDevice: 'inhaler/selectedDevice',
      flow: 'inhaler/flow',
      maxFlow: 'inhaler/maxFlow',
      ambient: 'inhaler/ambient',
      flowDampened: 'inhaler/flowDampened',
      maxFlowDampened: 'inhaler/maxFlowDampened',
      maxFlowDampened1: 'inhaler/maxFlowDampened1',
      ambientDampened: 'inhaler/ambientDampened',
      resistanceFactor: 'inhaler/resistanceFactor',
      isPWA: 'inhaler/isPWA',
    }),
    isCalibration() {
      return false;
    },
    timeoutEnabled() {
      return !this.isCalibration;
    },
    resetTreshold() {
      return this.ambient;
    },
    tableResultStyle() {
      const maxValue = 310;
      const minValue = 30;
      const range = maxValue - minValue;
      const clampedValue = Math.max(minValue, Math.min(this.maxFlowDampened, maxValue));
      const percentage = ((maxValue - clampedValue) / range) * 100;
      return `height: 360px; background: linear-gradient(to bottom, transparent ${percentage}%, #bee5e6 ${percentage}%); border: 1px solid red;`;
    }

  },

  created() {
    this.initialize();
    setTimeout(() => {
      if(this.maxFlowDampened >= 1) {
        this.showButton = true;
        window.scrollTo(0, document.body.scrollHeight);
      }
      this.viewResults();
    }, 5000);
  },

  destroyed() {
    this.analyser?.stop();
    if (this.resetTO) {
      clearTimeout(this.resetTO);
      this.resetTO = null;
    }
  },

  methods: {
    strongStyle() {
      return 'padding: 3px 8px;';
    },

    async initialize() {
      await this.$store.dispatch('inhaler/fetchAudioStream');
      this.analyser = new AudioAnalyser(this.stream, this.analyserSetValueHandler);
      this.analyser.init();
      this.analyser.start();

      let vh = window.innerHeight;
      let elContainer = document.getElementsByClassName("main-section-area");
      if (elContainer.length) {
        elContainer[0].style.height = vh + 'px';
      }
    },

    analyserSetValueHandler(audioLevel) {
      const flow = Math.floor(audioLevel);
      this.$store.dispatch('inhaler/setFlow', flow);

      if (this.analyser._active && flow > this.resetTreshold && this.timeoutEnabled) {
        if (this.resetTO) {
          clearTimeout(this.resetTO);
          this.resetTO = null;
        }
        this.resetTO = setTimeout(() => {
          this.$store.dispatch('inhaler/clearFlow');
        }, this.clearDelay);
      }
    },

    viewResults() {
      this.analyser?.stop();
      this.$router.push('/main/result');
    }
  }
}
</script>

<style>
.disabled-button {
  background-color: gray;
  color: white;
  cursor: not-allowed;
}
</style>